module.exports = __webpack_public_path__ + "media/images/icons/pin-dd1d9c0cb9345c2021012da3b46c58ba.svg";